module.exports = __webpack_public_path__ + "img/icon-home-grey.8f31c37b.png";